{
	"actions": {
		"cancel": "Annulla",
		"delete": "Elimina gruppo",
		"open": "Apri gruppo",
		"open_menu": "Apri il menu delle azioni"
	},
	"add_members": {
		"added_one": "{{count}} membro aggiunto a «{{name}}».",
		"added_other": "{{count}} membri aggiunti a «{{name}}».",
		"already": "Già membro",
		"cap_hint": "Puoi aggiungerne fino a {{max}} alla volta.",
		"description_created": "Gruppo creato. Ora aggiungi le persone che ne faranno parte.",
		"failed_description": "Una o più persone non sono più attive nell'organizzazione. Rimuovile dall'elenco e riprova.",
		"failed_title": "Nessuno è stato aggiunto.",
		"pending": "Aggiunta…",
		"picker_empty": "Nessuna persona trovata.",
		"picker_label": "Persone da aggiungere",
		"placeholder": "Cerca per nome o email",
		"selected_one": "{{count}} selezionata",
		"selected_other": "{{count}} selezionate",
		"skip": "Più tardi",
		"submit": "Aggiungi",
		"title": "Aggiungi membri"
	},
	"columns": {
		"actions": "Azioni",
		"members": "Membri",
		"name": "Nome",
		"visibility": "Visibilità"
	},
	"delete": {
		"confirm": "Elimina gruppo",
		"description": "I membri perderanno l'accesso ai file condivisi con il gruppo. L'azione non può essere annullata.",
		"pending": "Eliminazione…",
		"title": "Eliminare «{{name}}»?"
	},
	"detail": {
		"not_found_action": "Torna ai gruppi",
		"not_found_description": "Potrebbe essere stato eliminato. Torna all'elenco per trovare quello che cerchi.",
		"not_found_title": "Questo gruppo non esiste più",
		"tab_members": "Membri",
		"tab_settings": "Impostazioni",
		"unavailable_description": "Potrebbe essere stato eliminato, oppure è privato e non ne fai parte.",
		"unavailable_title": "Questo gruppo non è disponibile"
	},
	"empty": {
		"first_description": "Con un gruppo condividi file e cartelle con un intero team in un solo passaggio. Chi entra nel gruppo più tardi riceve l'accesso da solo.",
		"first_title": "Ancora nessun gruppo",
		"mine_action": "Mostra tutti i gruppi",
		"mine_description": "Qui trovi i gruppi di cui fai parte.",
		"mine_title": "Non fai parte di nessun gruppo",
		"search_description": "Prova con un'altra parola, oppure <create>crea il gruppo «{{q}}»</create>",
		"search_hint": "Prova con un'altra parola.",
		"search_title": "Nessun gruppo contiene «{{q}}»"
	},
	"leave": {
		"action": "Abbandona gruppo",
		"confirm": "Abbandona",
		"description": "Perderai l'accesso ai file condivisi con il gruppo.",
		"description_manager": "Perderai l'accesso ai file condivisi con il gruppo e non potrai più gestirlo.",
		"left": "Non fai più parte di «{{group}}».",
		"pending": "Uscita…",
		"title": "Abbandonare «{{name}}»?"
	},
	"members": {
		"add": "Aggiungi membri",
		"empty_description": "Aggiungi persone per iniziare a condividere file.",
		"empty_title": "Il gruppo è vuoto",
		"remove": "Rimuovi",
		"removed": "{{name}} non fa più parte di «{{group}}».",
		"removing": "Rimozione di {{name}}…",
		"search_placeholder": "Cerca per nome o email",
		"undo": "Annulla",
		"undo_done": "{{name}} è di nuovo in «{{group}}».",
		"undo_failed": "Non è stato possibile rimettere {{name}} nel gruppo.",
		"undoing": "Ripristino di {{name}}…"
	},
	"mine": "I miei gruppi",
	"new": {
		"action": "Nuovo gruppo",
		"description": "Scegli il nome e la visibilità del gruppo.",
		"name": "Nome",
		"name_placeholder": "Per esempio, Marketing",
		"name_required": "Scrivi il nome del gruppo.",
		"name_taken": "C'è già un gruppo «{{name}}». Scegli un altro nome.",
		"pending": "Creazione…",
		"private_note": "Questo gruppo è privato: sarà visibile solo ai membri e agli amministratori.",
		"submit": "Crea gruppo",
		"title": "Nuovo gruppo",
		"visibility": "Visibilità"
	},
	"page_title": "Gruppi",
	"search_placeholder": "Cerca per nome",
	"settings": {
		"delete_action": "Elimina gruppo",
		"delete_label": "Elimina il gruppo",
		"delete_text": "I membri perderanno l'accesso ai file condivisi con questo gruppo. L'azione non può essere annullata.",
		"deleted": "Gruppo «{{name}}» eliminato.",
		"name": "Nome",
		"name_cancel": "Annulla la modifica del nome",
		"name_confirm": "Conferma il nuovo nome",
		"name_help": "Il nome deve essere univoco nell'organizzazione.",
		"renamed": "Gruppo rinominato in «{{name}}».",
		"renaming": "Salvataggio del nome…",
		"visibility": "Visibilità",
		"visibility_fixed": "Questo gruppo è privato: visibile solo ai membri e agli amministratori. Solo un amministratore può modificarne la visibilità.",
		"visibility_help": "Definisce chi può trovare il gruppo e vederne i membri.",
		"visibility_private_done": "Il gruppo ora è privato.",
		"visibility_public_done": "Il gruppo ora è pubblico.",
		"visibility_saving": "Salvataggio della visibilità…"
	},
	"total_one": "{{count}} gruppo",
	"total_other": "{{count}} gruppi"
}
